import EmployeeCategory from "../../api/LabService/LabServiceModel/EmployeeCategory"
import LabAccount from "../../api/LabService/LabServiceModel/LabAccount"
import TestToBePerform from "../../api/LabService/LabServiceModel/TestToBePerform"
import RegulatoryMode from "../../api/LabService/LabServiceModel/RegulatoryMode"
import State from "../../api/OrderRequests/OrderRequestsModel/State"
import { ServiceTypeCode } from "../../api/Administration/Model/ServiceType"
import Service from "../../api/Administration/Model/Service"
import { SampleType } from "../../api/LookupCodes/SampleType"
import { ServiceCode } from "../../api/LookupCodes/ServiceCode"

export const OTHER_REASON_TEXT = 'Other'

export enum ServiceTypeOld {
  Drug = "DRUG",
  Alcohol = "ALCOHOL",
  Physical = "PHYSICAL",
  POCT = "POINT OF CARE TEST (POCT)",
  Background = "BACKGROUND"
}

export const EmptyServiceData: ServiceDataModel = {
  id: 0,
  serviceTypeCode: ServiceTypeCode.None,
  serviceCode: ServiceCode.None,
  isMarketplace: false,
  isDOT: undefined,
  testToPerform: '',
  testToPerformObj: undefined,
  labAccount: '',
  labAccountObj: undefined,
  reqSpecimenCollection: '',
  observedCollection: false,
  regulatoryMode: '',
  regulatoryModeObj: undefined,
  category: '',
  categoryObj: undefined,
  selectedTests: [],
  selectedServices: [],
  selectedTestType: undefined,
  isValidMode: false
}

export interface ServiceDataModel {
  id: number
  serviceTypeCode: ServiceTypeCode
  serviceCode: ServiceCode
  isMarketplace: boolean
  isDOT?: boolean
  testToPerform: string
  testToPerformObj?: AlcoholTestSampleType | TestToBePerform
  labAccount: string
  labAccountObj?: LabAccount
  reqSpecimenCollection: string
  observedCollection: boolean
  regulatoryMode: string
  regulatoryModeObj?: RegulatoryMode
  category: string | number
  categoryObj?: EmployeeCategory
  selectedTests: TestToBePerform[]
  selectedServices: Service[]
  selectedTestType?: SampleType
  isValidMode: boolean
}

export interface ServiceOrderedModel {
  serviceCode: ServiceCode,
  serviceTypeCode: ServiceTypeCode,
  isDOT?: boolean,
  labAccountDesc?: string
  testToPerformDesc?: string
}

export interface GovLabModel {
  labAccount?: string
  labCode?: string
  labClientMemberId?: number
}

export interface GovPanelModel {
  panelCode?: string
  panelDescription?: string
  testToPerform?: string
}

export interface GovServiceDataModel extends GovLabModel, GovPanelModel {
  id?: number
  serviceType?: ServiceTypeOld
  sampleType?: string
  isDOT?: boolean
  testDetailID?: string
}


export interface DonorInformationModel {
  idType?: string
  idTypeObj?: GetRegulatoryModeDonor
  state?: State | undefined
  stateCode?: string | undefined
  states?: State[] | undefined
  donorId?: string
  firstName?: string
  middleInitial?: string
  lastName?: string
  eveningPhone?: string
  daytimePhone?: string
  birthdate?: Date
  gender?: string
  personId?: number
  accessCode?: number
  email?: string
  firstNameReadOnly?: boolean
  middleInitialReadOnly?: boolean
  lastNameReadOnly?: boolean
  homePhoneReadOnly?: boolean
  workPhoneReadOnly?: boolean
  genderReadOnly?: boolean
  stateReadOnly?: boolean
  showPotentialMatches?: boolean
  idReadOnly?: boolean
  address?: DonorAddressModel
}

export interface DonorAddressModel {
  Address1: string
  Address2: string | null
  City: string
  State: string
  Zip: string
}

export interface ScheduleModel {
  timezone: string | undefined,
  overrideAllowed: boolean,
  hoursUntilExpires: number | undefined,
  expirationDate: Date | undefined,
  formattedExpirationDate: string,
  displayExpirationDate: string,
  comment: string,
  proceedImmediately:boolean
  extendExpirationHours: number
}

export interface Reason {
  BeginEffectiveDate: string,
  Code: string | number | null,
  Description: string,
  EndEffectiveDate: string,
  TestReasonID: number,
  UpdateDate: string,
  UpdateMethod: string | number | null,
  UserLogin: string | number | null
}

export interface AlcoholTestSampleType {
  BeginEffectiveDate: string,
  ClientID: number,
  Code: string,
  Description: string,
  EndEffectiveDate: string,
  IsAlcohol: boolean,
  IsPoct: boolean,
  SampleTypeID: string | number,
  TestDetails: string | number | null,
  UpdateDate: string,
  UpdateMethod: string | number | null,
  UserLogin: string | number | null
  PanelID?: number
  SampleTypeCode?: string
}

export interface GetRegulatoryModeDonor {
  Description: string
  PrimaryIDType: string
  Rank: number
  DisplayState: boolean
}

export interface Collector {
  VendorID: string | number
  ParentVendorID: string | null
  FFID: string
  Name: string
  Code: string
  Type: string | null
  Address1: string
  Address2: string | null
  City: string
  State: string
  Zip: string
  Phone: string | null
  HoursOfOperation: string
  Private: boolean
  Distance: number
  Latitude: number
  Longitude: number
  UseDOTForm: boolean
  FFEnabled: boolean
  OutOfNetwork: boolean
  iVendorID: number
  SiteID: string | null
  Fax: string | null
}
